// extracted by mini-css-extract-plugin
export default {"main":"Main_main__PQ0YD","item1":"Main_item1__ccbAg","item2":"Main_item2__w5Zsz","item3":"Main_item3__G11xp"};